<template>
  <div id="app">
    <v-app>
      <v-content class="rounded rounded-md">
      <!-- side bar -->
      <v-navigation-drawer color="grey-darken-2" permanent>
        <v-img class="mx-auto"
          :width="200"
          src="@/assets/logo.png"
        ></v-img>

        <v-divider class="mb-5"></v-divider>

        <!-- data binding example -->
        <v-list-item class="text-center" :title="survey_num" subtitle="Surveys"></v-list-item>
        <v-list-item class="text-center" :title="indicator_num" subtitle="Indicators"></v-list-item>

        <v-divider class="mt-5"></v-divider>

        <router-link style="text-decoration: none; color: inherit;" to="/">
          <v-list-item v-list-item link title="Welcome"></v-list-item>
        </router-link>

        <router-link style="text-decoration: none; color: inherit;" to="/search">
          <v-list-item v-list-item link title="Search"></v-list-item>
        </router-link>
        
        <router-link style="text-decoration: none; color: inherit;" to="/communities">
          <v-list-item v-list-item link title="Community Overviews"></v-list-item>
        </router-link>

        <router-link style="text-decoration: none; color: inherit;" to="/about">
          <v-list-item v-list-item link title="About"></v-list-item>
        </router-link>
        

      </v-navigation-drawer>

      <!-- top bar -->
      <v-app-bar
        color="grey-lighten-2"
        flat
        title="Explore Ecological Monitoring Initiatives"
      >
        <template v-slot:append>
          <router-link to="/login">
            <v-btn
              v-if="!$store.state.isUserLoggedIn">
              Staff
            </v-btn>
          </router-link>

          <v-btn
            v-if="$store.state.isUserLoggedIn"
            @click="logout">
            Log Out
          </v-btn>
          
          <router-link to="/register">
            <v-btn
              v-if="$store.state.isUserLoggedIn">
              Register
            </v-btn>
          </router-link>
        </template>
      </v-app-bar>

      <!-- main area -->
      <v-main>
        <router-view/>
      </v-main>
      
      <!-- footer -->
      <v-footer app width="auto" class="bg-grey-lighten-2">
          <v-row justify="center" no-gutters>
            2024 - DFO
          </v-row>
      </v-footer>
    </v-content>

    </v-app>
  </div>
</template>

<script>
import SearchService from '@/services/SearchService'

export default {
  data () {
    return {
      survey_num: null,
      indicator_num: null
    }
  },

  created() {
    this.loadNum()
  },

  methods: {
    async loadNum () {
      const response = await SearchService.entryNum()
      console.log(response)
      this.survey_num = response.data.survey_num
      this.indicator_num = response.data.indicator_num
    },
    
    logout () {
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      // redirect to homepage
      this.$router.push({
        name: 'welcome'
      })
    }
  }
}

</script>
